import request from '@/utils/request';

/*律师列表*/
export function getLawyerList(parameter) {
    return request({
      url: '/lawyer',
      method: 'get',
      params: parameter
    })
  }
  //律师详情
export function getLawyerDetail(parameter) {
  return request({
    url: '/lawyer/'+parameter.id,
    method: 'get',
  })
}